// shifts_search timestamps were once time-only strings ("4:30 pm")
// paired with a separate shift_day; they became full org-local datetimes
// ("2026-07-23 4:30 pm") and now carry the weekday for the model's
// benefit ("2026-07-23 (Thursday) 4:30 pm"). Persisted transcripts
// contain every generation, so split the date prefix off when present
// and drop the weekday, which the widget derives itself.
export function splitShiftDatetime(value: string | null | undefined): {
    readonly day: string | null;
    readonly time: string | null;
} {
    if (!value) {
        return { day: null, time: null };
    }
    const match = /^(\d{4}-\d{2}-\d{2})(?: \([A-Za-z]+\))? (.+)$/.exec(value);
    return match
        ? { day: match[1] ?? null, time: match[2] ?? null }
        : { day: null, time: value };
}
